export function respostaFormatadaByPerguntaId(dados, pergunta_id) {
  if (dados) {
    let elementoEncontrado = dados.find(function (objeto) {
      return objeto.idPergunta === pergunta_id;
    });

    if (elementoEncontrado) {
      return elementoEncontrado?.respostaFormatada;
    }

    return ""
  }
};
